'use client';

import React from 'react';

import PrimaryButton from '@/components/ui/Button/PrimaryButton';

type ContentCarouselButtonProps = {
  data: {
    title: string;
    slug?: string;
    buttonType?: string;
    heading?: { raw: string } | { json: any };
    description?: { raw: string };
    functionality?:
      | 'internal_link'
      | 'external_link'
      | 'call'
      | 'show_form'
      | 'enquire_now'
      | undefined;
    isLink?: boolean;
    formId?: string;
  };
  className?: string;
  type?: 'button' | 'submit';
  disabled?: boolean;
  onShowForm?: () => void;
  onEnquireNow?: () => void;
};

const ContentCarouselButton: React.FC<ContentCarouselButtonProps> = ({
  data,
  className = '',
  type = 'button',
  disabled = false,
  onShowForm,
  onEnquireNow,
}) => {
  return (
    <PrimaryButton
      data={data}
      type={type}
      disabled={disabled}
      widthFitContent
      paddingClassName="px-4 py-2"
      onShowForm={onShowForm}
      onEnquireNow={onEnquireNow}
      className={`rounded-md text-sm ${className}`}
    />
  );
};

export default ContentCarouselButton;
